import { userAxios } from '../index'
import { withBackendDates, withCompareDates } from '@/core/utils/dashboardDates'

/**
 * POST insurance/admin-data. Con `throwOnError` relanza el error (p. ej. 422 de fechas)
 * para que el llamador muestre el mensaje del backend; por defecto lo silencia.
 * Contrato §10: fechas `m-d-Y` (o con hora).
 */
export const getAdminData = async (data, { throwOnError = false } = {}) => {
  try {
    return await userAxios
      .post(`insurance/admin-data`, withBackendDates(data))
      .then(res => res.data)
  } catch (error) {
    if (throwOnError) throw error
    console.log(error)
  }
}

/** Contrato §10: compare exige `Y-m-d H:i:s` (no `m-d-Y`). */
export const compareFacilities = async data => {
  try {
    return await userAxios
      .post(`insurance/admin-data/compare`, withCompareDates(data))
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

export const getAdminDataPaginated = async (page, data, { throwOnError = false } = {}) => {
  try {
    return await userAxios
      .post(`insurance/admin-data?page=${page}`, withBackendDates(data))
      .then(res => res.data)
  } catch (error) {
    if (throwOnError) throw error
    console.log(error)
  }
}

export const getDetailsOfficeVisit = async id => {
  try {
    return await userAxios.get(`insurance/officeVisits/${id}`).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

export default {
  getAdminData,
  getAdminDataPaginated,
  getDetailsOfficeVisit,
  compareFacilities,
}
